import { useState } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import {
  Settings as ConfigIcon,
  Theaters as ShowTimeIcon,
  LockOpen as ForceIcon,
} from "@mui/icons-material";
import MymTitlesConfigPanel from "../mym/MymTitlesConfigPanel";
import ForceInviteConfigSection from "../mym/ForceInviteConfigSection";
import ForceAutoOffSection from "../mym/ForceAutoOffSection";
import ShowTimeManagement from "../showTime/ShowTimeManagement";

const HOME_TABS = [
  { id: "config", label: "Jukebox Config", icon: ConfigIcon },
  { id: "showtime", label: "Show time", icon: ShowTimeIcon },
  { id: "force", label: "Force config", icon: ForceIcon },
];

const GigHomeTab = () => {
  const [activeSubTab, setActiveSubTab] = useState("config");
  const activeIndex = HOME_TABS.findIndex((t) => t.id === activeSubTab);

  return (
    <Box
      sx={{
        p: { xs: 2, md: 3 },
        maxWidth: activeSubTab === "showtime" ? 1400 : 900,
        mx: "auto",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
        <ConfigIcon sx={{ fontSize: 28, color: "#1DB954" }} />
        <Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: "#fff",
              fontSize: { xs: "1.25rem", md: "1.5rem" },
              letterSpacing: -0.3,
            }}
          >
            Gig Mode Home
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.45)", fontSize: "0.85rem", mt: 0.25 }}>
            Jukebox config, show time, and force settings
          </Typography>
        </Box>
      </Box>

      <Tabs
        value={activeIndex === -1 ? 0 : activeIndex}
        onChange={(_, idx) => setActiveSubTab(HOME_TABS[idx].id)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          mb: 2.5,
          minHeight: 44,
          borderBottom: "1px solid rgba(255,255,255,0.08)",
          "& .MuiTabs-indicator": {
            backgroundColor: "#1DB954",
            height: 3,
            borderRadius: "3px 3px 0 0",
          },
          "& .MuiTab-root": {
            color: "rgba(255,255,255,0.45)",
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.9rem",
            minHeight: 44,
            gap: 0.75,
            "&.Mui-selected": { color: "#1DB954" },
          },
        }}
      >
        {HOME_TABS.map(({ id, label, icon: Icon }) => (
          <Tab
            key={id}
            icon={<Icon sx={{ fontSize: 18 }} />}
            iconPosition="start"
            label={label}
          />
        ))}
      </Tabs>

      {activeSubTab === "config" && (
        <MymTitlesConfigPanel showSplashEdit showForceSections={false} />
      )}

      {activeSubTab === "showtime" && <ShowTimeManagement embedded />}

      {activeSubTab === "force" && (
        <Box>
          <ForceInviteConfigSection compact />
          <ForceAutoOffSection compact />
        </Box>
      )}
    </Box>
  );
};

export default GigHomeTab;
